import { SET_TOKEN } from './mutations.js';
import { createSession } from '../../api/session.api.js';

const LOGIN_USER = 'Login user',
	LOGOUT_USER = 'Logout user';

export { LOGIN_USER, LOGOUT_USER };

export default {
	[LOGIN_USER]({ commit }, { form: session }) {
		return createSession({ session }).then(response => {
			const { authToken } = response.data;

			commit(SET_TOKEN, { token: authToken });
		});
	},
	[LOGOUT_USER]({ commit }) {
		return new Promise(resolve => {
			resolve();
		}).finally(() => {
			commit(SET_TOKEN, { token: null });
		});
	}
};
